// in src/MyLoginPage.js
import React, { useState, useEffect } from "react";
// import { connect } from "react-redux";
import { ThemeProvider } from "@mui/styles";
// import GoogleLogin from "react-google-login";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "./common/common";
import { rollbarConfigUser } from "./globs/rollbar";
import login_navender_logo from "./images/navender_logo.png";
import clickitLogo from "./images/clickit.svg";
import holcimPlus from "./images/holcim-plus.svg";

const apiUrl = RUN_TIME_API_ENDPOINT;
const googleClientID = "" + process.env.REACT_APP_GOOGLE_CLIENT_ID + "";

const MyLoginPage = (props) => {
  const [unautherized, setUnautherized] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [clickitLogoSet, setClickitLogoSet] = useState(false);

  console.log("googleClientID", googleClientID);
  const responseGoogle = (response) => {
    console.log("response 12", response);
    let url = "";
    if (response.credential) {
      setShowLoader(true);
      // const email = response.profileObj.email;
      // const googleName = response.profileObj.name;
      // const google_user_id = response.googleId;
      // const tokenId = response.tokenId;

      const clientId = response.clientId;
      const credential = response.credential;
      const select_by = response.select_by;

      url = `${apiUrl}/login`;
      const options = CommonHeaderOption();
      options.method = "POST";
      options.headers = {
        authorization: credential,
        "Content-Type": "application/json",
      };
      options.credential = "include";
      options.body = JSON.stringify({ select_by });
      // console.log('options to login',options);
      return fetch(url, options)
        .then((res) => {
          console.log("res >>>", res);
          if (res.status < 200 || res.status >= 300) {
            setUnautherized(true);
            throw new Error(res.statusText);
          }
          return res.json();
        })
        .then((resp) => {
          setShowLoader(false);
          setUnautherized(false);
          console.log("our use ", resp.data);
          // if (resp.data.email || resp.data.name) {
          //   const email = resp.data.email;
          //   const name = resp.data.name;
          //   url = `${apiUrl}/whitelist_users/google_user_name`;
          //   const options = CommonHeaderOption();
          //   options.method = "POST";
          //   options.body = JSON.stringify({ email, name });
          //   options.credential = 'include';
          //   return fetch(url, options)
          //     .then((res) => {
          //       if (res.status === 200) {
          //         console.log("res >>>", res);
          //         window.location.href = "/#";
          //         localStorage.setItem("__state", JSON.stringify(resp.data));
          //       }

          //       // return res.json();
          //     })
          //     .catch((error) => {
          //       console.log(error);
          //     });
          // }

          // e.preventDefault();
          console.log("resp our daa -->>", resp.data);
          rollbarConfigUser(resp.data);
          // Save app type
          localStorage.setItem("app_type", resp.data.app_type);

          // console.log(
          //   "saved app_type:",
          //   localStorage.getItem("app_type")
          // );
          localStorage.setItem("__state", JSON.stringify(resp.data));
          window.location.href = "/#";
        })
        .catch((error) => {
          localStorage.removeItem("__state");
        });
    }
  };

   useEffect(() => {
    const appType = localStorage.getItem("app_type");
    if(!appType)
    {
    const current_ip = localStorage.getItem("currentip");
    if(!current_ip)
    {
    fetch(`${process.env.REACT_APP_API_URL}/get_ip_location`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // METHOD 2
       const supportedCountries = ["FR"];
       const showLogo = supportedCountries.includes(data.data.country_code);
       localStorage.setItem("currentip", data.data.country_code);
        setClickitLogoSet(showLogo);
         document.title = showLogo
                ? "Clickit Admin Dashboard"
                : "HOLCIM+ Admin Dashboard";

           const favicon = document.getElementById("favicon");

            if (favicon) {
            favicon.href = showLogo
                ? "/favicon.ico"
                : "/favicon2.ico";
            }
      })
      .catch((error) => {
        setClickitLogoSet(false);
        document.title = "HOLCIM+ Admin Dashboard"; 
        const favicon = document.getElementById("favicon");
        favicon.href ="/favicon2.ico";
        console.error("Error:", error);
      });
    }
   }
  }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={props.theme}>
        <div className="google-login-page">
          {/* <img src={login_navender_logo} /> */}
          <img src={clickitLogoSet ? clickitLogo : holcimPlus} />
          <div className="google-login-button">
            {/* <GoogleLogin
                //  clientId="789188763856-6no23r2k2aa4cp3gtq6d27vn94lhp1pa.apps.googleusercontent.com"
                clientId={googleClientID}
                buttonText="Sign in with Google"
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
                // cookiePolicy={'single_host_origin'}
              /> */}
            <GoogleOAuthProvider clientId={googleClientID}>
              <GoogleLogin
                onSuccess={responseGoogle}
                onError={responseGoogle}
              />
            </GoogleOAuthProvider>
            {/* <p className="na-url-msg">Clickit admin has a new home!</p>
              <p className="na-url-msg">We've moved to a new link : <a href="https://admin-mea.clickitapp.io/" target="_blank">https://admin-mea.clickitapp.io/</a> Please bookmark the new link.</p>
              <a href="https://admin-mea.clickitapp.io/" target="_blank" rel="noreferrer">
                <button  className="na-url-btn">Go there now!</button>
              </a> */}
          </div>
          <p className={unautherized ? "user" : "not-user"}>
            Unauthorized user
          </p>
          {showLoader && !unautherized && <div className="login-loader" />}
        </div>
         <div className="google-footer">
          <p>© HOLCIM {new Date().getFullYear()} | App version {process.env.REACT_APP_VERSION}</p>
        </div>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default MyLoginPage;
